// extracted by mini-css-extract-plugin
export var legendIndicator = "_cc-1";
export var legendRight = "_cc-0";